export const SMALL_ALPHABET_FONT_SIZE = "120%";

export const containsSmallAlphabetChars = (text: string): boolean => {
  const arabic = "\\u0600-\\u06FF";
  const hebrew = "\\u0590-\\u05FF";
  const thai = "\\u0E00-\\u0E7F";
  const chinese = "\\u4E00-\\u9FFF";
  const hiragana = "\\u3040-\\u309F";
  const katakana = "\\u30A0-\\u30FF";
  const hangul = "\\uAC00-\\uD7AF";
  const devanagari = "\\u0900-\\u097F";
  const tamil = "\\u0B80-\\u0BFF";
  const telugu = "\\u0C00-\\u0C7F";

  const pattern = new RegExp(
    `[${arabic}${hebrew}${thai}${chinese}${hiragana}${katakana}${hangul}${devanagari}${tamil}${telugu}]`
  );
  return pattern.test(text);
};
